import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/about-us/projects/atmp-xb")({
  head: () => buildRouteHead("/en/about-us/projects/atmp-xb", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd/projects/atmp-xb", replace: true });
  },
});
